import clsx from 'clsx'
import { motion } from 'framer-motion'

import { useNaturalPowerRatio } from './NaturalPowerCalculatorProvider'

export function NaturalPowerSource() {
  const naturalPowerRatio = useNaturalPowerRatio()
  const allNaturalPower = naturalPowerRatio === 1

  return (
    <div
      className={clsx(
        'absolute w-52 origin-bottom-left transition-all duration-300 ease-out',
        naturalPowerRatio === 0 && 'left-0 -translate-x-0 scale-0 stroke-6 opacity-0 duration-1000',
        naturalPowerRatio === 0.25 && 'left-1/8 -translate-x-1/8 scale-25 stroke-5',
        naturalPowerRatio === 0.5 && 'left-1/4 -translate-x-1/4 scale-50 stroke-4',
        naturalPowerRatio === 0.75 && 'left-3/8 -translate-x-3/8 scale-75 stroke-3',
        naturalPowerRatio === 1 && 'left-1/2 -translate-x-1/2 scale-100 stroke-2',
      )}>
      <motion.svg
        viewBox="0 0 174 175"
        fill="none"
        xmlns="http://www.w3.org/2000/motion.svg"
        className={clsx(
          'absolute stroke-3 blur-sm',
          allNaturalPower ? 'opacity-100 animate-pulse' : 'opacity-0 animate-none',
        )}>
        <path
          className="stroke-mint"
          d="M87.5 98.56v-8.503c0-9.589-5.913-26.914-20.649-38.709"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          className="stroke-mint"
          d="M71.518 71.678a23.27 23.27 0 0 1-19.434-23.27c0-5.914 2.301-18.22 5.913-20.65a18.059 18.059 0 0 0 14.736 11.796 15.373 15.373 0 0 1 13.68 19.178M87.5 90.057a34.074 34.074 0 0 1 15.982-22.663"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          className="stroke-mint"
          d="M103.482 78.902c7.544.511 19.434-3.644 19.434-15.759 0-12.114-8.854-23.59-8.854-23.59s-2.972 11.795-11.795 14.768a14.928 14.928 0 0 0-9.173 10.804"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </motion.svg>
      <svg viewBox="0 0 174 175" fill="none" xmlns="http://www.w3.org/2000/svg" className="relative z-20">
        <path
          d="M44.477 87.5a7.928 7.928 0 0 0 7.863-7.991 7.927 7.927 0 0 0-7.863-7.991 7.83 7.83 0 0 0-6.393 3.196 14.48 14.48 0 0 0 .32-3.196 15.982 15.982 0 0 0-15.727-15.982A15.982 15.982 0 0 0 7.27 68.32a10.005 10.005 0 0 0-6.233 9.302 9.91 9.91 0 0 0 9.845 9.973l33.595-.096ZM133.592 133.785a8.218 8.218 0 0 0 8.215-8.215 8.216 8.216 0 0 0-8.215-8.183 8.182 8.182 0 0 0-8.183 8.183 8.195 8.195 0 0 0 2.386 5.807 8.176 8.176 0 0 0 5.797 2.408v0ZM116.268 108.564a57.347 57.347 0 0 1-28.768 7.704 57.347 57.347 0 0 1-41.554-17.709M31.499 45.467A57.536 57.536 0 0 1 87.5 1.197a57.537 57.537 0 0 1 57.536 57.535 57.059 57.059 0 0 1-2.781 17.709M23.571 173.804H7.59v-63.929h15.982V173.804ZM87.5 173.804v-38.358l-21.32 13.937v-13.937l-21.288 13.937v-13.937l-21.32 13.937v24.421H87.5ZM128.606 136.597l-4.667 37.206M137.908 136.597l4.635 37.206"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          className={clsx(
            'transition-colors',
            allNaturalPower ? 'stroke-mint delay-300 duration-300' : 'stroke-current',
          )}
          d="M87.5 98.56v-8.503c0-9.589-5.913-26.914-20.649-38.709"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          className={clsx(
            'transition-colors',
            allNaturalPower ? 'stroke-mint delay-300 duration-300' : 'stroke-current',
          )}
          d="M71.518 71.678a23.27 23.27 0 0 1-19.434-23.27c0-5.914 2.301-18.22 5.913-20.65a18.059 18.059 0 0 0 14.736 11.796 15.373 15.373 0 0 1 13.68 19.178M87.5 90.057a34.074 34.074 0 0 1 15.982-22.663"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          className={clsx(
            'transition-colors',
            allNaturalPower ? 'stroke-mint delay-300 duration-300' : 'stroke-current',
          )}
          d="M103.482 78.902c7.544.511 19.434-3.644 19.434-15.759 0-12.114-8.854-23.59-8.854-23.59s-2.972 11.795-11.795 14.768a14.928 14.928 0 0 0-9.173 10.804"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        fill="none"
        width={101}
        height={101}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 85 85"
        className={clsx(
          'absolute top-[99.5px] left-[109px] fill-navy/50 stroke-current z-30',
          naturalPowerRatio > 0 && 'animate-spin-slow',
          naturalPowerRatio === 0 && 'stroke-5',
          naturalPowerRatio === 0.25 && 'stroke-4',
          naturalPowerRatio === 0.5 && 'stroke-3',
          naturalPowerRatio === 0.75 && 'stroke-2',
          naturalPowerRatio === 1 && 'stroke-2',
        )}>
        <path
          d="M36.455 1.56v26.626a6.392 6.392 0 0 0 6.138 6.201 6.393 6.393 0 0 0 6.169-6.2c0-9.11-3.58-26.627-12.307-26.627ZM10.148 68.429l23.078-13.33a6.393 6.393 0 0 0 2.27-8.406 6.392 6.392 0 0 0-8.439-2.237c-7.895 4.539-21.288 16.397-16.91 23.973ZM81.205 57.752 58.127 44.455a6.202 6.202 0 0 0-8.407 2.237 6.201 6.201 0 0 0 2.27 8.407c7.894 4.57 24.867 10.133 29.215 2.653Z"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  )
}
